import { EBroadcastTypes } from '@/types/session.types';
import { TBroadcastTypePickerOptions } from './broadcast-type-picker.types';

export const BROADCAST_TYPE_OPTIONS: TBroadcastTypePickerOptions[] = [
  EBroadcastTypes.greenroom,
  EBroadcastTypes.rtmps,
  'teams',
  'zoom',
];
